import React, { useState } from 'react'
import './services.css';
import FlightBooking from './Flightbooking';
import HotelReservation from './HotelReservation';
import InquiryForm from './InquiryForm';

function Services() {

  const [isOpen, setIsOpen] = useState(false);
    const [isHotelReservationOpen, setIsHotelReservationOpen] = useState(false);
    const [InquiryFormOpen, setInquiryFormOpen] = useState(false);
  
  return (
    <>
    <FlightBooking isOpen={isOpen} setIsOpen={setIsOpen} />
      <HotelReservation isOpen={isHotelReservationOpen} setIsOpen={setIsHotelReservationOpen} />
      <InquiryForm isOpen={InquiryFormOpen} setIsOpen={setInquiryFormOpen} />
 <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Services
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Services
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Service Start */}
      <div className="container-xxl services-section">
        <div className="container">
          <div className="text-center services-heading wow fadeInUp" data-wow-delay="0.1s">
            {/* <h6 className="section-title">Services</h6> */}
            <h1 className="mb-5">Our Services</h1>
          </div>
          <div className="row g-4 services-grid">
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>✈  </h1>                    </div>
                  </div>
                  <h5 className="service-title">Air Ticketing</h5>
                  <p className="service-text">
                    Domestic & International flights, Group & Corporate bookings

                  </p>
                  <button onClick={() => setIsOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>🏨  </h1>                    </div>
                  </div>
                  <h5 className="service-title">Hotel Reservations</h5>
                  <p className="service-text">
Budget to luxury worldwide, Corporate rates
                  </p>
                  <button onClick={() => setIsHotelReservationOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>🚗</h1>                    </div>
                  </div>
                  <h5 className="service-title">  Transport Services</h5>
                  <p className="service-text">
Airport transfers, Car rentals, Chauffeur services
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>🗺</h1>                    </div>
                  </div>
                  <h5 className="service-title">  Tour Packages</h5>
                  <p className="service-text">
Customized, Honeymoon, Religious & Group tours
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-4 services-grid">
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
                     <h1>🕌</h1>
                    </div>
                  </div>
                  <h5 className="service-title">  Umrah & Ziyarat</h5>
                  <p className="service-text">
                  Visa processing, Flight & Hotel packages
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>🛡  </h1>                    </div>
                  </div>
                  <h5 className="service-title">Travel Insurance</h5>
                  <p className="service-text">
                    Health, Trip, Baggage & Schengen-approved
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>💼</h1>                    </div>
                  </div>
                  <h5 className="service-title">  Corporate Travel</h5>
                  <p className="service-text">
End-to-end planning, Reporting & Expense tracking
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
              <div className="service-card">
                <div className="service-card-inner">
                  <div className="service-card-top">
                    <div className="service-icon">
<h1>📋</h1>                    </div>
                  </div>
                  <h5 className="service-title">  Visa Assistance</h5>
                  <p className="service-text">
Tourist, Business, Student, Embassy appointments
                  </p>
                  <button onClick={() => setInquiryFormOpen(true)} className="service-action">
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}

      {/* Why Choose Start */}
      <div className="container-xxl py-5 why-choose-section">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            {/* <h6 className="section-title bg-white text-center text-primary px-3">Why Choose</h6> */}
            <h1 className="mb-5">WHY CHOOSE FALCON DESTINATIONS?</h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-certificate"></i>
                </div>
                <h5>IATA Certified</h5>
                <p>Fully licensed and IATA-approved travel management company</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-globe"></i>
                </div>
                <h5>International Standards</h5>
                <p>Services aligned with global quality benchmarks at economical rates</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-th-large"></i>
                </div>
                <h5>Comprehensive Services</h5>
                <p>One-stop solution for all travel, visa, insurance and documentation needs</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-building"></i>
                </div>
                <h5>Corporate Expertise</h5>
                <p>Dedicated corporate travel solutions with expense management & reporting</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-desktop"></i>
                </div>
                <h5>Digital Platform</h5>
                <p>White-label web portal for seamless bookings and centralized control</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="why-choose-card">
                <div className="why-choose-icon">
                  <i className="fa fa-users"></i>
                </div>
                <h5>Trusted Group</h5>
                <p>Part of the reputed Al-Rahim Group — reliability backed by heritage</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose End */}

      {/* Specialized Services Start */}
      <div className="container-xxl py-5 specialized-services-section">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            {/* <h6 className="section-title bg-white text-center text-primary px-3">Specialized</h6> */}
            <h1 className="mb-5">SPECIALIZED SERVICES</h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="specialized-service-card">
                <div className="specialized-service-header">
                  <i className="fa fa-mosque specialized-service-icon"></i>
                  <h4>Umrah & Ziyarat Services</h4>
                </div>
                <ul className="specialized-service-list">
                  <li><i className="fa fa-check-circle"></i> Iran / Iraq Visa Processing</li>
                  <li><i className="fa fa-check-circle"></i> Complete Flight + Hotel Packages</li>
                  <li><i className="fa fa-check-circle"></i> Guided Ziyarat Transportation</li>
                  <li><i className="fa fa-check-circle"></i> Group & Individual arrangements</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="specialized-service-card">
                <div className="specialized-service-header">
                  <i className="fa fa-building specialized-service-icon"></i>
                  <h4>Corporate Travel Management</h4>
                </div>
                <ul className="specialized-service-list">
                  <li><i className="fa fa-check-circle"></i> End-to-end business travel planning</li>
                  <li><i className="fa fa-check-circle"></i> Expense reporting & tracking</li>
                  <li><i className="fa fa-check-circle"></i> Dedicated account management</li>
                  <li><i className="fa fa-check-circle"></i> 24/7 support for corporate clients</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="specialized-service-card">
                <div className="specialized-service-header">
                  <i className="fa fa-passport specialized-service-icon"></i>
                  <h4>Visa & Documentation</h4>
                </div>
                <ul className="specialized-service-list">
                  <li><i className="fa fa-check-circle"></i> Tourist, Business & Student visas</li>
                  <li><i className="fa fa-check-circle"></i> Embassy & Drop Box appointments</li>
                  <li><i className="fa fa-check-circle"></i> Document Attestation & Translation</li>
                  <li><i className="fa fa-check-circle"></i> Notarization & Legal processing</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.7s">
              <div className="specialized-service-card">
                <div className="specialized-service-header">
                  <i className="fa fa-desktop specialized-service-icon"></i>
                  <h4>Online Web Portal</h4>
                </div>
                <ul className="specialized-service-list">
                  <li><i className="fa fa-check-circle"></i> White-label web query app</li>
                  <li><i className="fa fa-check-circle"></i> Faster bookings & fewer follow-ups</li>
                  <li><i className="fa fa-check-circle"></i> Centralized control for businesses</li>
                  <li><i className="fa fa-check-circle"></i> Enhanced customer satisfaction</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Specialized Services End */}
      
    {/* Testimonial Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Testimonial
          </h6>
          <h1 className="mb-5">Our Clients Say!!!</h1>
        </div>
        <div className="owl-carousel testimonial-carousel position-relative">
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-1.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-2.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-3.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-4.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
        </div>
      </div>
    </div> */}
    {/* Testimonial End */}
    </div>
    
    </>
   
  )
}

export default Services